<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="role.ident === 'admin' ? 'Admin jogkör módosítása nem lehetséges' : 'Módosítás'"
      placement="top"
      v-can="'role.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        :disabled="role.ident === 'admin'"
        @click="updateRole"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="role.ident === 'admin' ? 'Admin jogkör törlése nem lehetséges' : 'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'role.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteRole"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
          :disabled="role.ident === 'admin'"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['role'],
  data() {
    return {
      deleteButtonLoader: false,
      deleteConfirmVisible: false
    };
  },
  methods: {
    async deleteRole() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('role/delete', this.role.id);
        this.$store.dispatch('role/fetchAll');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    async updateRole() {
      this.$router.push('/roles/update/' + this.role.id);
    }
  }
};
</script>
